import classnames from 'classnames';
import Card from 'components/Card';
import Image from 'components/Image';
import React from 'react';

const CSS = require('./FeatureCard.module.less');

interface FeatureCardProps {
  href: string;
  title: string;
  subtitle: string;
  cloudinaryId: string;
  alt: string;
  label?: string;
}

const IMAGE_SIZES = { width: 184, height: 256 };

function FeatureCard({
  href,
  title,
  subtitle,
  cloudinaryId,
  label,
}: FeatureCardProps) {
  return (
    <Card as={'li'} className={CSS.FeatureCard}>
      <Image
        width={IMAGE_SIZES.width}
        height={IMAGE_SIZES.height}
        src={`https://withlocals-com-res.cloudinary.com/image/upload/${cloudinaryId}`}
        options={IMAGE_SIZES}
        className={CSS.CardImage}
        loading="lazy"
      />
      <div className={CSS.CardContent}>
        {label && <div className={CSS.Label}>{label}</div>}
        <a
          href={href}
          className={classnames(CSS.Link, {
            [CSS.LinkSmaller]: title.length > 12,
          })}
        >
          <span className={CSS.SubTitle}>{subtitle}</span>
          {title}
        </a>
      </div>
    </Card>
  );
}

export default FeatureCard;
